import React from 'react';
import './ArtistsPage.css';
import artistsData from '../../data/artistsData.json';
import { useTranslation } from 'react-i18next';

function importAll(r) {
  let images = {};
  r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); });
  return images;
}
const images = importAll(require.context('../../assets/images', false, /\.(png|jpe?g|svg)$/));

const ArtistCard = ({ artist, style }) => {
  const { i18n } = useTranslation();

  return (
    <div className="artist-card" style={style}>
      <div className="artist-card-content">
        <img src={images[artist.imageSrc]} alt={artist.name.en} className="artist-image" />
        <div className="artist-info">
          <span className="artist-name">{artist.name[i18n.language]}</span>
          <p className="artist-bio">{artist.bio[i18n.language]}</p>
        </div>
      </div>
    </div>
  );
};

function ArtistsPage() {
  const { t } = useTranslation();

  return (
    <div className="artists-page">
      <h1>{t('navArtists')}</h1>
      <div className="artists-grid">
        {artistsData.map((artist, index) => (
          <ArtistCard 
            key={artist.id} 
            artist={artist} 
            style={{ animationDelay: `${index * 50}ms` }}
          />
        ))}
      </div>
    </div>
  );
}

export default ArtistsPage;